export class ProductFilter {
    
    constructor(isActive: boolean, isInactive: boolean, name?: string, categoryId?: string) {
        this.name = name;
        this.categoryId = categoryId;
        this.isActive = isActive;
        this.isInactive = isInactive;
    }

    name?: string;
    categoryId?: string;
    isActive: boolean;
    isInactive: boolean;

}